import { BarkPaymentsCardModal } from '../components/payments/credit-card';
import { getPrimaryPaymentMethod } from '../components/payments/payment-methods';
import whatIsBarkModal, {
	whatIsBarkTestimonialVideosJs,
} from '../components/what-is-bark/what-is-bark-modal';
import { handleScaAuthenticationRequest } from '../components/payments/sca';
import {_n, currency} from "@bark/bark-core/src/helpers/number-formatting";
import {
    _t, continueToBusinessAddress,
    initializeGooglePlacesAutoComplete,
    isUSTaxComplianceActive,
    isUSTaxCompliant, saveBusinessAddress,
    tracking
} from "@bark/bark-core";
import {generateWalletOptions} from "../helpers/payments/helpers";

export default async function () {
	try {
		whatIsBarkModal();
		whatIsBarkTestimonialVideosJs();
		LegacySignUpOfferPage();
	} catch (e) {
		console.log(e);
	}
}

export const LegacySignUpOfferPage = () => {
	'use strict';

	let currentPurchaseId;

	let setAsAtu;

	let pack;

	let sellerProfileId;

	let paymentType;

	let $creditModal;

	let paymentMethod = false;

	let USTaxCompliantStatus;

	let paymentRequest;

	function renderStarterPack(starterPack) {
		if (!starterPack) {
			return false;
		}

		pack = starterPack;

		$('.js-starter-pack-container .js-discount-pct').text(starterPack.discount);
		$('.js-starter-pack-container .js-estimated-responses').text(starterPack.responses);
        $('.js-starter-pack-container .js-n-credits').text(_n(starterPack.credits));
        $('.js-starter-pack-container .js-currency-symbol').text('');
        $('.js-starter-pack-container .js-price').text(
            currency(starterPack.discounted_price),
		);
		$('.js-starter-pack-container .js-vat-toggle')[
			(starterPack.vat > 1 || $('#js-show-tax-disclaimers-us').length) ? 'removeClass' : 'addClass'
		]('d-none');
		$('.js-starter-pack-container .js-price-per-credit').text(
            currency(starterPack.price_per_credit),
        );
	}

	/**
	 * Show a purchase pack success modal
	 * @param {int} n_credits The number of credits that have been purchased
	 */
	function showPurchaseSuccessModal(n_credits) {
		Bark.hideLoading();

		$('.modal').modal('hide');

		$('#credit-pack-purchase-success-modal').modal('show');
		$('.js-credit-pack-purchase-success-modal .js-n-extra-credits').text(
			n_credits ? n_credits : '',
		);
	}


    /**
     * Load the entire page
     */
    async function loadPage() {
        if (isUSTaxComplianceActive()) {
            USTaxCompliantStatus = await isUSTaxCompliant();
            if (!USTaxCompliantStatus) {
                initializeGooglePlacesAutoComplete();
            }
        }
    }

	const packPurchaseComplete = (sellerInvoiceId) => {
		showPurchaseSuccessModal(pack.credits);

		trackPurchase({
			invoice_id: sellerInvoiceId,
			credits: pack.credits,
			price: pack.discounted_price,
			name: pack.id > 1 ? 'SellerAlloc' + pack.id : 'StarterPack',
		});
	};

	/**
	 * Purchases credit packs
	 * @param {int|string} creditPackId The ID of the credit pack to purchase
	 * @param {boolean} setAsAutoTopup True to set this pack as the ATU pack
	 * @param {string} token [optional] A string to set as a new stripe token
	 * @param {string|null} paymentIntentId
	 */
	async function purchaseCredits(
		creditPackId,
		setAsAutoTopup,
		token,
		paymentIntentId = null,
	) {
		var payload = {
			cpid: creditPackId,
			autoTopupSetting: Number(setAsAutoTopup),
			sToken: token,
			tracking: Bark.getTrackableParameters(),
		};

		if (!creditPackId) {
			// Should not happen
			console.error('No credit pack');
			bugsnagClient.notify(new Error('No credit pack selected in purchase flow'));
			return;
		}

		Bark.showLoading();

		if (paymentIntentId) {
			payload.paymentIntentId = paymentIntentId;
		}

		if (!token && paymentMethod?.id) {
			payload.paymentMethodId = paymentMethod.id;
		}

		Bark.api(
			`/creditpack/${creditPackId}/purchase/`,
			payload,
			function (e) {
				packPurchaseComplete(e.data.seller_invoice_id);
			},
			function (error) {
				const errorResponse = error.responseJSON;

				Bark.hideLoading();

				if (errorResponse?.error?.type === 'action_required') {
					handleScaAuthenticationRequest(
						$creditModal,
						errorResponse?.error?.error_data?.client_secret,
						(paymentIntent) => {
							purchaseCredits(creditPackId, setAsAutoTopup, null, paymentIntent.id);
						},
					);
				} else {
					errorModal(errorResponse.error?.message || null);
				}
			},
			'POST',
		);
	}

	/**
	 * Show the error modal
	 * @param {string} msg [optional] The error message to show
	 */
	function errorModal(msg) {
		Bark.hideLoading();
		BarkPaymentsCardModal.showModalErrorText(
			$creditModal,
			msg || 'An error occurred completing your request',
		);
		BarkPaymentsCardModal.showCardModal($creditModal, paymentRequest);
	}

	/**
	 * Track a purchase in GA
	 * @param {object} transaction
	 */
	function trackPurchase(transaction) {
		window.ga?.('send', 'event', 'purchased_credit_pack', transaction.credits + ' credits');

		window.ga?.('ecommerce:addTransaction', {
			id: 'cp_inv_' + transaction.invoice_id,
			affiliation: sellerProfileId,
			revenue: transaction.price,
			shipping: '0',
			tax: '0',
		});

		window.ga?.('ecommerce:addItem', {
			id: 'cp_inv_' + transaction.invoice_id,
			name: transaction.name,
			sku: transaction.name,
			category: transaction.name,
			price: transaction.price,
			quantity: '1',
		});

		window.ga?.('ecommerce:send');
	}

	const starterPackContainer = $('.js-starter-pack-container');

	paymentType = starterPackContainer.data('payment-type');
	sellerProfileId = starterPackContainer.data('seller-profile-id');

	$creditModal = BarkPaymentsCardModal.initCardModal(
		'.js-card-payment-modal',
		(token) => {
			purchaseCredits(currentPurchaseId, setAsAtu, token.id);
		},
		() => console.log('not done'),
	);

	Bark.api(
		'creditpacks',
		null,
		function (e) {
			$('.js-sp-page-shown').addClass('d-none');
			$('.js-sp-page-hidden').removeClass('d-none');
			renderStarterPack((e.data || [])[0]);
		},
		function (f) {
			bugsnagClient.notify(new Error('Failed to get credit packs from API'), {
				metaData: f,
			});
			document.location = '/sellers/home/';
		},
	);

	$('.js-close-success-modal')
		.off('click.navigate')
		.on('click.navigate', function () {
			$('.modal').modal('hide');
            Bark.hideLoading();
			document.location = '/sellers/home/';
		});

	$('.js-purchase-pack')
		.off('click.purchasepack')
		.on('click.purchasepack', async function () {
			var t = $(this);
			var scope = t.parent();
            currentPurchaseId = t.data('pack-id');

            if (isUSTaxComplianceActive() && !USTaxCompliantStatus) {
                let $callback = function () {
                    purchasePack(scope, t.data('pack-id'), t.data('atuavail'));
                }
                openUSTaxCompliantModal({});
                bindUSTaxComplianceNextAction($callback);
            } else{
                purchasePack(scope, t.data('pack-id'), t.data('atuavail'));
            }
		});

    function openUSTaxCompliantModal(data) {
        $('#addressCompliance')
            .data(data)
            .modal('show');
        $('#next-button-business-address').html(_t('seller_settings_credits:us-tax-compliance.buy-credits-confirm-button'));
        $('.js-close-business-address-modal').removeClass('d-none');
        tracking('Wayfair', `US Tax Compliance - offer begin`, {
                context: "Purchase credits"
            },
        );
        continueToBusinessAddress("Purchase credits (offer page)");
    }

    function bindUSTaxComplianceNextAction($callback) {
        $('#next-button-business-address')
            .off('click')
            .on('click', async function () {
                Bark.logEvent('click', 'next button business address');
                if (isUSTaxComplianceActive()) {
                    Bark.showLoading();
                    saveBusinessAddress("Purchase credits (offer page)", function () {
                        USTaxCompliantStatus = true;
                        let $container = $('#addressCompliance');
                        $container.modal('hide');
                        Bark.hideLoading();
                        $callback();
                    });
                }
            });
    }

	async function purchasePack(scope, currentPurchaseId, atuAvail ) {
        setAsAtu = false;
        if (atuAvail) {
            setAsAtu = +$('.js-atu-toggle', scope)[0].checked;
        }

        $('.js-add-new-card-title').removeClass('d-none');
        $('.js-update-card-title').addClass('d-none');
        $('.js-payment-card-purchase-text').text('Purchase');

        if (paymentMethod === false) {
            paymentMethod = await getPrimaryPaymentMethod(sellerProfileId);
        }

		paymentRequest = generateWalletOptions(true, {
			amount: pack.discounted_price * 100,
			isUpsell: false,
			cpId: 1,
			packType: 'credit-pack',
			userId: Bark.USER.userId,
			onWalletPaymentComplete: async (_, __, initPaymentIntentResponse) => {
				packPurchaseComplete(initPaymentIntentResponse.invoiceId);
			}
		})

        if (!paymentMethod?.id) {
			BarkPaymentsCardModal.showCardModal($creditModal, paymentRequest);
        } else {
            purchaseCredits(currentPurchaseId, setAsAtu);
        }
    }

	// Open the 'what is bark' modal
	$('a.what-are-credits').on('click', function (e) {
		//window.whatIsBarkIndex = 1;
		//window.whatIsBarkShowAsBack = true;
		window.ga?.('send', 'event', 'dashboard', 'button click', 'what are credits');
		location.hash = '#what-are-credits';

		$('#whatIsBarkModal').modal('show');
		e.preventDefault();
	});

	// Close the what is bark modal
	$('#whatIsBarkModal .close-modal-cross').on('click', function () {
		window.ga?.('send', 'event', 'dashboard', 'button click', 'what are credits - close');
		//window.whatIsBarkShowAsBack = false;
	});

    loadPage();
};
